import React, { useMemo } from 'react';

import { Box } from '@material-ui/core';

import { useHistory } from 'react-router-dom';

import { AppA, GridCellWithAvatar } from '@vyce/core/src/components';
import { GRID_PAGE_SIZE } from '@vyce/core/src/constants';
import { WidgetWrapper, WidgetWrapperProps } from '@vyce/core/src/components/Dashboard/WidgetWrapper';
import { AppSearchInput } from '@vyce/core/src/components/inputs/AppSearchInput';

import { useWidgetData } from './hooks';
import { Props } from './types';
import { InfiniteTable } from '../../../components/InfiniteTable';
import { EnrichedColumnProps } from '../../../components/InfiniteTable/types';
import { getAvatar } from '../../../utils';
import { CustomActionCell } from '../../teamPage/components';
import { TeamMember } from '../../../types';

/* Team's workers widget*/

export const TeamWorkersWidget = (props: Props & WidgetWrapperProps) => {
  const history = useHistory();
  const pathname = history.location.pathname;

  const {
    workers,
    total,
    sortModel,
    loading,
    isLoadingList,
    isMobile,
    handleSearchChange,
    getTeamMembers,
    resetLoadingList,
    handleSortModelChange,
    deleteTeamMembers,
    changeManager,
  } = useWidgetData(props);

  const columns: EnrichedColumnProps<TeamMember>[] = useMemo(
    () => [
      {
        field: 'first_name',
        headerName: 'Name',
        flex: 2,
        width: 150,
        sortable: true,
        renderCell: row => (
          <GridCellWithAvatar
            link={`${pathname}/${row?.first_name}_${row?.user_id}`}
            avatarUrl={row.avatar}
            avatarPlaceholder={getAvatar(row.gender)}
            name={`${row.first_name} ${row.last_name}`}
          />
        ),
      },
      {
        field: 'email',
        headerName: 'Email',
        flex: 2,
        width: 240,
        sortable: true,
        renderCell: row => <AppA content={row.email} href={`mailto: ${row.email}`} />,
      },
      {
        field: 'phone',
        headerName: 'Phone Number',
        width: 160,
        sortable: true,

        renderCell: row => <AppA content={row.phone} href={`tel: ${row.phone}`} />,
      },
      {
        field: 'customCell',
        headerName: 'Actions',
        width: 80,
        sortable: false,
        renderCell: row => (
          <CustomActionCell
            isManager={row?.is_manager}
            userId={row.user_id}
            teamId={props.teamIds?.[0]}
            deleteTeamMembers={deleteTeamMembers}
            changeManager={changeManager}
          />
        ),
      },
    ],
    [props.teamIds]
  );

  return (
    <WidgetWrapper {...props}>
      <Box width="100%" height="100%">
        <Box width="200px">
          <AppSearchInput onChange={handleSearchChange} isSmall isBorder fullWidth expanded={!isMobile} />
        </Box>

        <InfiniteTable
          isLoading={loading}
          data={workers}
          columns={columns}
          rowCount={total}
          rowHeight={54}
          height="calc(100% - 78px)"
          pageSize={GRID_PAGE_SIZE}
          isLoadingList={isLoadingList}
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          onLoadMore={getTeamMembers}
          resetLoadingList={resetLoadingList}
        />
      </Box>
    </WidgetWrapper>
  );
};
